export default "__VITE_ASSET__QXGi5_3N__"